import _objectSpread from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { createRef, useCallback, useEffect, useState } from 'react';
import Cropper from 'react-easy-crop';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from '@guryou/hooks';
import { Spinner } from '@guryou/html-components';
import { resetState, stateIsLoaded, stateIsLoading, UPLOAD_FILE } from '@guryou/redux';
import Slider from '@material-ui/core/Slider';
import { useTheme } from '@material-ui/core/styles';
import { ContainedButton, IconButton } from '../buttons';
import { Block, DefaultText, FlexRow, Title } from '../content';
import { HiddenField } from '../forms';
import { DeleteIcon } from '../icons';
const defaultState = {
  crop: {
    x: 0,
    y: 0
  },
  zoom: 1,
  selectedUrl: null,
  croppedInfo: null,
  file: null
};
const CropImageMedia = _ref => {
  var _ls$croppedInfo, _ls$croppedInfo2, _ls$croppedInfo3, _ls$croppedInfo4, _ls$croppedInfo5, _ls$croppedInfo6, _ls$croppedInfo7, _ls$croppedInfo8;
  let {
    minWidth,
    minHeight,
    onSuccess,
    file,
    handleCropChange,
    removeFile
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const [ls, setLs] = useState(defaultState);
  const uploadImage = useSelector(state => state.files.upload);
  const inputFileRef = /*#__PURE__*/createRef();
  const onSuccessCallback = useCallback(() => {
    onSuccess && onSuccess(ls.selectedUrl);
  }, [ls.selectedUrl, onSuccess]);
  useEffectOnce(() => {
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      setLs(ps => _objectSpread(_objectSpread({}, ps), {}, {
        selectedUrl: reader.result
      }));
    });
    reader.readAsDataURL(file);
    setLs(ps => _objectSpread(_objectSpread({}, ps), {}, {
      file
    }));
  });
  useEffect(() => {
    if (stateIsLoaded(uploadImage)) {
      dispatch(resetState(UPLOAD_FILE));
      onSuccessCallback();
      setLs(defaultState);
    }
  }, [dispatch, ls.selectedUrl, onSuccessCallback, uploadImage, uploadImage.version]);
  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setLs(ps => _objectSpread(_objectSpread({}, ps), {}, {
      croppedInfo: croppedAreaPixels
    }));
    handleCropChange && handleCropChange(croppedAreaPixels);
  },
  //eslint-disable-next-line
  []);
  const onCropChange = crop => {
    setLs(ps => _objectSpread(_objectSpread({}, ps), {}, {
      crop
    }));
  };
  const onZoomChange = zoom => {
    setLs(ps => _objectSpread(_objectSpread({}, ps), {}, {
      zoom
    }));
  };
  const removeSelectedUrl = useCallback(() => {
    setLs(ps => _objectSpread(_objectSpread({}, ps), {}, {
      selectedUrl: '',
      crop: {
        x: 0,
        y: 0
      },
      croppedInfo: ''
    }));
    removeFile && removeFile(pv => _objectSpread(_objectSpread({}, pv), {}, {
      file: null
    }));
  }, [removeFile]);
  const onSelectFile = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setLs(ps => _objectSpread(_objectSpread({}, ps), {}, {
          selectedUrl: reader.result
        }));
      });
      reader.readAsDataURL(e.target.files[0]);
      setLs(ps => _objectSpread(_objectSpread({}, ps), {}, {
        file: e.target.files[0]
      }));
    }
  };
  const controlsPosition = ls.selectedUrl ? {
    bottom: 0
  } : {
    top: 0
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    hidden: true,
    id: "cropImage",
    type: "file",
    accept: "image/*",
    onChange: onSelectFile,
    ref: inputFileRef
  }), /*#__PURE__*/React.createElement(HiddenField, {
    name: "metadataX",
    value: (_ls$croppedInfo = ls.croppedInfo) === null || _ls$croppedInfo === void 0 ? void 0 : _ls$croppedInfo.x
  }), /*#__PURE__*/React.createElement(HiddenField, {
    name: "metadataY",
    value: (_ls$croppedInfo2 = ls.croppedInfo) === null || _ls$croppedInfo2 === void 0 ? void 0 : _ls$croppedInfo2.y
  }), /*#__PURE__*/React.createElement(HiddenField, {
    name: "metadataWidth",
    value: (_ls$croppedInfo3 = ls.croppedInfo) === null || _ls$croppedInfo3 === void 0 ? void 0 : _ls$croppedInfo3.width
  }), /*#__PURE__*/React.createElement(HiddenField, {
    name: "metadataHeight",
    value: (_ls$croppedInfo4 = ls.croppedInfo) === null || _ls$croppedInfo4 === void 0 ? void 0 : _ls$croppedInfo4.height
  }), ls.croppedInfo && /*#__PURE__*/React.createElement(FlexRow, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Title, {
    textAlign: "center",
    xs: 6,
    title: (_ls$croppedInfo5 = ls.croppedInfo) === null || _ls$croppedInfo5 === void 0 ? void 0 : _ls$croppedInfo5.width,
    description: t('PROVIDER-GALLERY.width'),
    whiteSpace: "nowrap"
  }), /*#__PURE__*/React.createElement(Title, {
    textAlign: "center",
    xs: 6,
    title: (_ls$croppedInfo6 = ls.croppedInfo) === null || _ls$croppedInfo6 === void 0 ? void 0 : _ls$croppedInfo6.height,
    description: t('PROVIDER-GALLERY.height'),
    whiteSpace: "nowrap"
  }), minHeight > ((_ls$croppedInfo7 = ls.croppedInfo) === null || _ls$croppedInfo7 === void 0 ? void 0 : _ls$croppedInfo7.height) && minWidth > ((_ls$croppedInfo8 = ls.croppedInfo) === null || _ls$croppedInfo8 === void 0 ? void 0 : _ls$croppedInfo8.width) && /*#__PURE__*/React.createElement(DefaultText, {
    color: theme.palette.error.main
  }, t('VALIDATIONS.imageTooSmall'))), stateIsLoading(uploadImage) ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement(Block, {
    position: "relative",
    height: "400px"
  }, ls.selectedUrl && /*#__PURE__*/React.createElement(Block, {
    margin: 0,
    position: "absolute",
    height: "300px",
    top: 0
  }, /*#__PURE__*/React.createElement(Cropper, {
    image: ls.selectedUrl,
    crop: ls.crop,
    zoom: ls.zoom,
    aspect: 5 / 3.125,
    onCropChange: onCropChange,
    onCropComplete: onCropComplete,
    onZoomChange: onZoomChange
  })), /*#__PURE__*/React.createElement(Block, _extends({
    margin: 0,
    position: "absolute",
    textAlign: "center"
  }, controlsPosition), !ls.selectedUrl && /*#__PURE__*/React.createElement(ContainedButton, {
    color: "primary",
    onClick: () => inputFileRef.current.click(),
    text: t('PROVIDER-GALLERY.+image')
  }), ls.selectedUrl && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Block, {
    xs: 6,
    padding: 5,
    margin: "auto"
  }, /*#__PURE__*/React.createElement(Slider, {
    value: ls.zoom,
    min: 1,
    max: 3,
    step: 0.1,
    "aria-labelledby": "Zoom",
    onChange: (_, zoom) => setLs(ps => _objectSpread(_objectSpread({}, ps), {}, {
      zoom
    }))
  })), /*#__PURE__*/React.createElement(FlexRow, {
    margin: "auto",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: DeleteIcon,
    color: "secondary",
    onClick: removeSelectedUrl
  }))))));
};
export default CropImageMedia;